import moment from 'moment';
import get from 'lodash.get';

// Global Types
import { AppState } from 'services/types';

// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
import { selectBinTotalsByPersonAndDate } from 'services/harvestEventDocuments/selectors';

// Local Types
import { OwnProps } from '.';

const selectStartDate = (
    _state: AppState,
    props: OwnProps
): string | undefined => props.startDate;
const selectEndDate = (_state: AppState, props: OwnProps): string | undefined =>
    props.endDate;
const selectPersonIds = (
    _state: AppState,
    props: OwnProps
): number[] | undefined => props.personIds;

const selectTotalBinsForDateAndPeople = createDeepEqualSelector(
    [
        selectBinTotalsByPersonAndDate,
        selectStartDate,
        selectEndDate,
        selectPersonIds
    ],
    (binTotalsByPersonAndDate, startDate, endDate, personIds) => {
        let totalBinsForDatesAndPeople = 0;

        if (!personIds || !personIds.length || !endDate || !startDate) {
            return totalBinsForDatesAndPeople;
        }

        const numberOfDays = moment(endDate, 'YYYY-MM-DD').diff(
            moment(startDate, 'YYYY-MM-DD'),
            'days'
        );

        personIds.forEach(personId => {
            for (let day = 0; day <= numberOfDays; day += 1) {
                const date = moment(startDate)
                    .add(day, 'days')
                    .format('YYYY-MM-DD');
                const totalBinsForDateAndPerson = get(
                    binTotalsByPersonAndDate,
                    [date, personId],
                    0
                );
                totalBinsForDatesAndPeople += totalBinsForDateAndPerson;
            }
        });

        return totalBinsForDatesAndPeople;
    }
);

const makeSelectTotalBinsForDateAndPeople = (): typeof selectTotalBinsForDateAndPeople =>
    selectTotalBinsForDateAndPeople;

export { selectTotalBinsForDateAndPeople, makeSelectTotalBinsForDateAndPeople };
